/* eslint-disable react/prop-types */
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PaymentFormStripeSubscription from './StripeForm/subscription';
import PaymentFormMercadopagoSubscription from './MercadopagoForm/subscription';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectCurrentContent, selectCurrentContentId, selectCurrentContentFichaPath } from '../../queries/selectors/contents';
import withNoMembershipPurchased from '../withNoMembershipPurchased';
import { getSelectedPlan, selectShoppingCartConfig } from '../../queries/selectors/shoppingCart';
import { selectActivePlanSubscription, selectProducts } from '../../queries/selectors/products';
import { selectAddOnSubscriptions, selectCouponApply, selectSingleSubscriptionClient } from '../../queries/selectors/bootstrap';
import { selectUserData, selectUserPaymentMethods } from '../../queries/selectors/user';
import withMembershipGuard from '../withMembershipGuard';
import { useTrackingScripts } from '../../utils/hooks/useInjectScripts';
import { ApplyCouponCodeRequest } from '../../queries/coupons';
import { connectRequest } from '../../utils/query';
import { selectClient, selectSearchObj } from '../../global-selectors';
import { pickPromoSlugFromSearchObj } from '../../utils';
import withAutoCaptcha from '../withAutoCaptcha';

const paymentMethodSubscription = {
  stripe: PaymentFormStripeSubscription,
  mercadopago: PaymentFormMercadopagoSubscription,
};

const PaymentFormPageSubscription = (props) => {
  const routePaymentMethod = props.match?.params?.methodId;
  const PaymentMethod = paymentMethodSubscription[routePaymentMethod];
  useTrackingScripts(props.plan)
  return PaymentMethod
    ? <PaymentMethod {...props} paymentMethod={routePaymentMethod} />
    : null;
};


const mapStateToProps = (state) => {
  const couponApply = selectCouponApply(state);
  const userData = selectUserData(state);
  const planSelected = getSelectedPlan(state);
  const couponCode = planSelected?.couponApply?.code;

  return ({
    content: selectCurrentContent(state),
    plan: getSelectedPlan(state),
    contentId: selectCurrentContentId(state),
    path: selectCurrentContentFichaPath(state),
    paymentMethod: selectCurrentPaymentMethod(state),
    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    userPaymentMethods: selectUserPaymentMethods(state),
    couponApply,
    token: userData?.token,
    userData,
    planSelected,
    couponCode,
    currentSubscription: selectActivePlanSubscription(state),
    methodId: selectCurrentPaymentMethod(state),
    shoppingCart: selectShoppingCartConfig(state),
    user: selectUserData(state),
    products: selectProducts(state),
    client: selectClient(state),
    addOnSubscriptions: selectAddOnSubscriptions(state),
    ...(couponCode && { code: couponCode }),
    promoSlug: pickPromoSlugFromSearchObj(selectSearchObj(state)),
  })
};

const mapPropsToConfig = (props) => {
  if (props?.code) {
   
    if (!props.isCaptchaEnabled) {
      return [ApplyCouponCodeRequest((( { captchaToken, ...rest }) => rest)(props))];
    } else if (props.captchaToken) {
      return [ApplyCouponCodeRequest({
        ...props,
        captchaToken: props.captchaToken
      })];
    }
  }
  return [];
}


const mapDispatchToProps = (dispatch, props) => ({
});


export default compose(
  withNoMembershipPurchased,
  withMembershipGuard,
  connect(mapStateToProps, mapDispatchToProps),
  withAutoCaptcha,
  connectRequest(mapPropsToConfig)
)(PaymentFormPageSubscription);
